<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div
			>推品数 <span class="yx-color-text-primary font-bold">{{ row.total_share_product_num }}</span></div
		>
		<div
			>选品数 <span class="yx-color-text-primary font-bold">{{ row.total_anchor_product_num }}</span></div
		>
		<div
			>寄样数 <span class="yx-color-text-primary font-bold">{{ row.total_sample_order_num }}</span></div
		>
		<div
			>开播数 <span class="yx-color-text-primary font-bold">{{ row.total_live_product_num }}</span></div
		>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
</style>
